export const LEVEL_CONFIG = [
  { level: 1,  name: "Story Explorer",      ehriPhase: "Pre-Alphabetic",              parentDescription: "Learning that letters represent sounds",           ageBand: "4-5" },
  { level: 2,  name: "Story Explorer",      ehriPhase: "Pre-Alphabetic",              parentDescription: "Recognizing letters and environmental print",      ageBand: "4-5" },
  { level: 3,  name: "Sound Detective",     ehriPhase: "Partial Alphabetic",          parentDescription: "Connecting letters to their sounds",               ageBand: "4-6" },
  { level: 4,  name: "Sound Detective",     ehriPhase: "Partial Alphabetic",          parentDescription: "Using beginning sounds to identify words",         ageBand: "5-6" },
  { level: 5,  name: "Letter Adventurer",   ehriPhase: "Partial Alphabetic",          parentDescription: "Sounding out simple words",                        ageBand: "5-7" },
  { level: 6,  name: "Letter Adventurer",   ehriPhase: "Partial Alphabetic",          parentDescription: "Reading CVC words with confidence",                ageBand: "5-7" },
  { level: 7,  name: "Word Builder",        ehriPhase: "Full Alphabetic",             parentDescription: "Reading short words independently",                ageBand: "6-8" },
  { level: 8,  name: "Word Builder",        ehriPhase: "Full Alphabetic",             parentDescription: "Decoding unfamiliar words using phonics patterns", ageBand: "6-8" },
  { level: 9,  name: "Reading Scout",       ehriPhase: "Full Alphabetic",             parentDescription: "Reading sentences with confidence",                ageBand: "7-9" },
  { level: 10, name: "Reading Scout",       ehriPhase: "Full Alphabetic",             parentDescription: "Understanding what they read",                     ageBand: "7-9" },
  { level: 11, name: "Story Navigator",     ehriPhase: "Consolidated Alphabetic",     parentDescription: "Understanding stories and context",                ageBand: "8-10" },
  { level: 12, name: "Story Navigator",     ehriPhase: "Consolidated Alphabetic",     parentDescription: "Recognizing common word patterns automatically",   ageBand: "8-10" },
  { level: 13, name: "Chapter Champion",    ehriPhase: "Consolidated Alphabetic",     parentDescription: "Reading chapter books fluently",                   ageBand: "9-11" },
  { level: 14, name: "Chapter Champion",    ehriPhase: "Consolidated Alphabetic",     parentDescription: "Strong vocabulary and reading stamina",            ageBand: "10-12" },
  { level: 15, name: "Reading Master",      ehriPhase: "Automatic Alphabetic",        parentDescription: "Advanced reading comprehension and analysis",      ageBand: "11-12" },
];

export const MASTERY_THRESHOLDS = [
  { min: 0.0,  max: 0.3,  label: "Just Getting Started", color: "#F59E0B", colorName: "amber"      },
  { min: 0.3,  max: 0.6,  label: "Practicing",           color: "#F59E0B", colorName: "amber"      },
  { min: 0.6,  max: 0.85, label: "Almost There",         color: "#14B8A6", colorName: "teal"       },
  { min: 0.85, max: 1.0,  label: "Mastered",             color: "#16A34A", colorName: "deep-green" },
];

export const READING_STAGES = {
  "Pre-Alphabetic":          { stageName: "Beginning Reader",  description: "Your child is building the foundation, learning that letters and sounds are connected." },
  "Partial Alphabetic":      { stageName: "Early Reader",      description: "Your child is starting to use letter sounds to figure out words. This is where phonics clicks." },
  "Full Alphabetic":         { stageName: "Growing Reader",    description: "Your child can sound out new words and is building reading independence." },
  "Consolidated Alphabetic": { stageName: "Strong Reader",     description: "Your child recognizes word patterns automatically and reads with fluency." },
  "Automatic Alphabetic":    { stageName: "Fluent Reader",     description: "Your child reads with speed, accuracy, and deep comprehension." },
};

export const LEITNER_BOX_LABELS = [
  { box: 1, label: "Just Learning",     color: "#F59E0B" },
  { box: 2, label: "Practicing",        color: "#D97706" },
  { box: 3, label: "Getting Stronger",  color: "#14B8A6" },
  { box: 4, label: "Almost There",      color: "#0D9488" },
  { box: 5, label: "Mastered",          color: "#16A34A" },
];

export function getLevelName(level) {
  const config = LEVEL_CONFIG.find(l => l.level === level);
  return config ? config.name : `Level ${level}`;
}

export function getLevelConfig(level) {
  return LEVEL_CONFIG.find(l => l.level === level) || null;
}

export function getEhriPhase(level) {
  const config = LEVEL_CONFIG.find(l => l.level === level);
  return config ? config.ehriPhase : null;
}

export function getReadingStage(level) {
  const phase = getEhriPhase(level);
  return phase ? READING_STAGES[phase] : null;
}

export function getMasteryLabel(probability) {
  const threshold = MASTERY_THRESHOLDS.find(t => probability >= t.min && probability < t.max);
  if (probability >= 1.0) return MASTERY_THRESHOLDS[MASTERY_THRESHOLDS.length - 1];
  return threshold || MASTERY_THRESHOLDS[0];
}

export function getMasteryColor(probability) {
  return getMasteryLabel(probability).color;
}

export function getLeitnerBoxLabel(boxNumber) {
  return LEITNER_BOX_LABELS.find(b => b.box === boxNumber) || { box: boxNumber, label: `Box ${boxNumber}`, color: "#94A3B8" };
}

export function getParentDescription(level) {
  const config = LEVEL_CONFIG.find(l => l.level === level);
  return config ? config.parentDescription : "";
}

export function getAgeBand(level) {
  const config = LEVEL_CONFIG.find(l => l.level === level);
  return config ? config.ageBand : null;
}
